import Vue from 'vue';
import VueRouter from 'vue-router';
//引入nprogress进度条
import NProgress from 'nprogress';
//引入nprogress进度条的样式
import 'nprogress/nprogress.css';
import store from '../store';

NProgress.configure({ showSpinner: false });

const NotFoundComponent = () => import(/* webpackChunkName: "notfoundentry" */ '../components/NotFoundComponent.vue');
const DefaultEntryComponent = () => import(/* webpackChunkName: "defaultentry" */ '../components/DefaultEntryComponent.vue');

// public
const PublicDefaultEntryComponent = () => import(/* webpackChunkName: "publicdefaultentry" */ '../components/public/DefaultEntryComponent.vue');
const PublicOrderFileDownloadComponent = () => import(/* webpackChunkName: "publicorderfiledownloadentry" */ '../components/public/OrderFileDownloadComponent.vue');
const PublicCustomerContactInfoComponent = () => import(/* webpackChunkName: "publiccustomercontactinfoentry" */ '../components/public/CustomerContactInfoComponent.vue');

// wechat
const WechatOAuthComponent = () => import(/* webpackChunkName: "wechatoauthentry" */ '../components/auth/WechatOAuthComponent.vue');
const WechatDefaultEntryComponent = () => import(/* webpackChunkName: "wechatdefaultentry" */ '../components/wechat/DefaultEntryComponent.vue');
const WechatEmployeeBindComponent = () => import(/* webpackChunkName: "wechatemployeebindentry" */ '../components/wechat/EmployeeBindComponent.vue');
const WechatPhoneBindComponent = () => import(/* webpackChunkName: "wechatphonebindentry" */ '../components/wechat/PhoneBindComponent.vue');
const QRLoginConfirmComponent = () => import(/* webpackChunkName: "qrloginconfirmentry" */ '../components/wechat/QRLoginConfirmComponent.vue');
const WechatOrderBindComponent = () => import(/* webpackChunkName: "wechatorderbindentry" */ '../components/wechat/OrderBindComponent.vue');
const WechatMyOrdersComponent = () => import(/* webpackChunkName: "wechatmyordersentry" */ '../components/wechat/MyOrdersComponent.vue');
const WechatBidResourcesComponent = () => import(/* webpackChunkName: "wechatbidresourcesentry" */ '../components/wechat/BidResourcesComponent.vue');
const OrderFileDownloadComponent = () => import(/* webpackChunkName: "orderfiledownloadentry" */ '../components/wechat/OrderFileDownloadComponent.vue');

const WechatEmployeeDefaultEntry = () => import(/* webpackChunkName: "wechatemployeedefaultentry" */ '../components/wechat/employee/EmployeeDefaultEntry.vue');
const WechatEmployeeAcceptOrderComponent = () => import(/* webpackChunkName: "wechatemployeeacceptorderentry" */ '../components/wechat/employee/AcceptOrderComponent.vue');
const WechatEmployeeAuditOrderComponent = () => import(/* webpackChunkName: "wechatemployeeauditorderentry" */ '../components/wechat/employee/AuditOrderComponent.vue');

const WechatModuleDocsIndexComponent = () => import(/* webpackChunkName: "wechatmoduledocsindexentry" */ '../components/wechat/docs/ModuleDocsIndexComponent.vue');
const WechatModuleDocsListComponent = () => import(/* webpackChunkName: "wechatmoduledocslistentry" */ '../components/wechat/docs/ModuleDocsListComponent.vue');
const WechatModuleDocDetailComponent = () => import(/* webpackChunkName: "wechatmoduledocdetailentry" */ '../components/wechat/docs/ModuleDocDetailComponent.vue');

// OPS
const OPSDefaultEntryComponent = () => import(/* webpackChunkName: "opsdefaultentry" */ '../components/ops/DefaultEntryComponent.vue');
const OPSIndexComponent = () => import(/* webpackChunkName: "opsindex" */ '../components/ops/IndexComponent.vue');
const OPSLoginComponent = () => import(/* webpackChunkName: "opslogin" */ '../components/ops/LoginComponent.vue');
const OPSDashboardComponent = () => import(/* webpackChunkName: "opsdashboard" */ '../components/ops/common/DashboardComponent.vue');

const OPSSalorDailyLogsComponent = () => import(/* webpackChunkName: "opssalordailylogs" */ '../components/ops/customers/SalorDailyLogsComponent.vue');
const OPSContactFormLogsComponent = () => import(/* webpackChunkName: "opscontactformlogs" */ '../components/ops/customers/ContactFormLogsComponent.vue');
const OPSContactFormsManageComponent = () => import(/* webpackChunkName: "opscontactformsmanage" */ '../components/ops/customers/ContactFormsManage.vue');
const OPSElecInvoiceLogsComponent = () => import(/* webpackChunkName: "opselecinvoicelogs" */ '../components/ops/customers/ElecInvoiceLogsComponent.vue');
const OPSCustomerArchivesManage = () => import(/* webpackChunkName: "opscustomerarchivesmanage" */ '../components/ops/customers/CustomerArchivesManage.vue');
const OPSCouponsManage = () => import(/* webpackChunkName: "opscouponsmanage" */ '../components/ops/customers/CouponsManage.vue');
const OPSContractInitComponent = () => import(/* webpackChunkName: "opscontractinit" */ '../components/ops/customers/ContractInitComponent.vue');

// sysmanages
const OPSWechatMPUsersComponent = () => import(/* webpackChunkName: "opswechatmpusers" */ '../components/ops/sysconfigs/WechatMPUsersComponent.vue');
const OPSDepartmentsComponent = () => import(/* webpackChunkName: "opsdepartments" */ '../components/ops/sysconfigs/DepartmentsComponent.vue');
const OPSEmployeesComponent = () => import(/* webpackChunkName: "opsemployees" */ '../components/ops/sysconfigs/EmployeesComponent.vue');
const OPSDictsManageComponent = () => import(/* webpackChunkName: "opsdictsmanage" */ '../components/ops/sysconfigs/DictsManageComponent.vue');
const OPSDBAManageComponent = () => import(/* webpackChunkName: "opsdbamanage" */ '../components/ops/sysconfigs/DBAManageComponent.vue');
const OPSPunchinImportComponent = () => import(/* webpackChunkName: "opspunchinimport" */ '../components/ops/sysconfigs/PunchinImportComponent.vue');
const OPSElecInvoiceLogsImportComponent = () => import(/* webpackChunkName: "opselecinvoicelogimport" */ '../components/ops/sysconfigs/ElecInvoiceLogsImportComponent.vue');
const OPSBlackListComponent = () => import(/* webpackChunkName: "opsblacklist" */ '../components/ops/sysconfigs/BlackListComponent.vue');
const OPSSystemCouponsManage = () => import(/* webpackChunkName: "opssyscouponsmanage" */ '../components/ops/sysconfigs/CouponsManage.vue');
const OPSSystemOSSFilesManage = () => import(/* webpackChunkName: "opsossfilesmanage" */ '../components/ops/sysconfigs/OSSFilesManage.vue');


const OPSBusinessUserAuditComponent = () => import(/* webpackChunkName: "opsplatuseraudit" */ '../components/ops/plat/BusinessUserAuditComponent.vue');

const OPSOrderTableComponent = () => import(/* webpackChunkName: "opsordertable" */ '../views/ops/order/List.vue');
const OPSSimpleOrderTableComponent = () => import(/* webpackChunkName: "opssimpleordertable" */ '../components/ops/orders/OrderSimpleTableComponent.vue');
const OPSCreateOrderComponent = () => import(/* webpackChunkName: "opscreateorder" */ '../components/ops/orders/CreateOrderComponent.vue');
const OPSEmployeePerformanceComponent = () => import(/* webpackChunkName: "opsemployeeperformance" */ '../components/ops/orders/EmployeePerformanceComponent.vue');
const OPSSalorPerformanceComponent = () => import(/* webpackChunkName: "opssalorperformance" */ '../components/ops/orders/SalorPerformanceComponent.vue');

const OPSCommonOrderStatisticsComponent = () => import(/* webpackChunkName: "opscommonorderstatistics" */ '../components/ops/statistics/CommonOrderStatisticsComponent.vue');
const OPSOrderServicePriceStatisticsComponent = () => import(/* webpackChunkName: "opsorderservicepricestatistics" */ '../components/ops/statistics/OrderServicePriceStatisticsComponent.vue');

const OPSAuditLogTableComponent = () => import(/* webpackChunkName: "opsauditlogtable" */ '../components/ops/orders/AuditLogTableComponent.vue');
const OPSAuditLogPrintComponent = () => import(/* webpackChunkName: "opsauditlogprint" */ '../components/ops/orders/AuditLogPrintComponent.vue');

const OPSCreatePaymentAuditComponent = () => import(/* webpackChunkName: "opscreatepaymentauditentry" */ '../components/ops/payments/audit/CreateAuditComponent.vue');
const OPSWXPaymentLogsComponent = () => import(/* webpackChunkName: "opswxpaymentlogsentry" */ '../components/ops/payments/WXPaymentLogsComponent.vue');

const OPSTechProgramResourcesComponent = () => import(/* webpackChunkName: "opstechprogramresourcesentry" */ '../components/ops/resources/TechProgramComponent.vue');
const OPSBusinessFilesResourcesComponent = () => import(/* webpackChunkName: "opsbusinessfileresourcesentry" */ '../components/ops/resources/BusinessFilesComponent.vue');
const OPSTrainFilesResourcesComponent = () => import(/* webpackChunkName: "opstrainfileresourcesentry" */ '../components/ops/resources/TrainFilesComponent.vue');

const OPSSelfDefaultEntryComponent = () => import(/* webpackChunkName: "opsselfdefaultentry" */ '../components/ops/self/DefaultEntryComponent.vue');
const OPSPunchinManageComponent = () => import(/* webpackChunkName: "opsselfpunchinmanageentry" */ '../components/ops/self/PunchinManageComponent.vue');

const OPSAddInvoiceComponent = () => import(/* webpackChunkName: "opsaddinvoiceentry" */ '../components/ops/finance/AddInvoiceComponent.vue');
const OPSOrderMonthSumTableComponent = () => import(/* webpackChunkName: "opsordermonthsumentry" */ '../components/ops/finance/OrderMonthSumTableComponent.vue');
const OPSFinanceOrderTableComponent = () => import(/* webpackChunkName: "opsfinanceorderlistentry" */ '../components/ops/finance/OrderTableComponent.vue');
const OPSFinanceCorpPayOrderTableComponent = () => import(/* webpackChunkName: "opsfinancecorppayorderlistentry" */ '../components/ops/finance/CorpPayOrderTableComponent.vue');
const OPSFinanceCorpPaymentLogsComponent = () => import(/* webpackChunkName: "opsfinancecorppaymentlogsentry" */ '../components/ops/finance/CorpPaymentLogsComponent.vue');
const OPSReceiveAccountBalancesComponent = () => import(/* webpackChunkName: "opsreceiveaccountbalancesentry" */ '../components/ops/finance/ReceiveAccountBalancesComponent.vue');
const OPSFinanceAccountSettlementsTable = () => import(/* webpackChunkName: "opsaccountsettlementstableentry" */ '../components/ops/finance/AccountSettlementsTable.vue');
const OPSPaymentAuditCheckTableComponent = () => import(/* webpackChunkName: "opspaymentauditchecktablesentry" */ '../components/ops/finance/PaymentAuditCheckTableComponent.vue');
const OPSPunchinsCheckTableComponent = () => import(/* webpackChunkName: "opspunchinschecktablesentry" */ '../components/ops/finance/PunchinsCheckComponent.vue');
const OPSPunchinVacationCheckComponent = () => import(/* webpackChunkName: "opspunchinvacationcheckentry" */ '../components/ops/finance/PunchinVacationCheckComponent.vue');
const OPSPaymentLogsComponent = () => import(/* webpackChunkName: "opspaymentlogsentry" */ '../components/ops/finance/PaymentLogsComponent.vue');
const OPSInvoiceLogsComponent = () => import(/* webpackChunkName: "opsinvoicelogsentry" */ '../components/ops/finance/InvoiceLogsComponent.vue');

const OPSHREmployeesComponent = () => import(/* webpackChunkName: "opshremployeesentry" */ '../components/ops/hr/EmployeesComponent.vue');

// Define some routes
// Each route should map to a component. The "component" can
// either be an actual component constructor created via
// `Vue.extend()`, or just a component options object.
// We'll talk about nested routes later.
const routes = [
    {
        path: '/',
        name: 'defaultEntry',
        component: DefaultEntryComponent,
        meta: { requiresAuth: false }
    },
    {
        path: '/auth/wechat',
        name: 'wechatAuthEntry',
        component: WechatOAuthComponent,
        meta: { requiresAuth: false }
    },
    {
        path: '/public',
        name: 'publicentry',
        component: PublicDefaultEntryComponent,
        children: [{
            path: 'orderFileDownload/:secret',
            name: 'publicorderfiledownloadentry',
            component: PublicOrderFileDownloadComponent
        }, {
            path: 'customerContactInfo/:secret',
            name: 'publiccustomercontactinfoentry',
            component: PublicCustomerContactInfoComponent
        }]
    },
    {
        path: '/wechat',
        name: 'wechatDefaultEntry',
        component: WechatDefaultEntryComponent,
        meta: { requiresAuth: true },
        children: [{
            path: 'employeeBind',
            name: 'wechatEmployeeBindEntry',
            component: WechatEmployeeBindComponent,
            meta: { requiresAuth: true }
        }, {
            path: 'phoneBind',
            name: 'wechatPhoneBindEntry',
            component: WechatPhoneBindComponent,
            meta: { requiresAuth: true }
        }, {
            path: 'qrLoginConfirm',
            name: 'qrLoginConfirmEntry',
            component: QRLoginConfirmComponent,
            meta: { requiresAuth: true }
        },{
            path: 'orderBind',
            name: 'wechatOrderBindEntry',
            component: WechatOrderBindComponent,
            meta: { requiresAuth: true }
        }, {
            path: 'myOrders',
            name: 'wechatMyOrdersEntry',
            component: WechatMyOrdersComponent,
            meta: { requiresAuth: true, keepAlive: true },
        }, {
            path: 'orderFileDownload',
            name: 'orderFileDownloadEntry',
            component: OrderFileDownloadComponent,
            meta: { requiresAuth: true }
        }, {
            path: 'bidResources',
            name: 'wechatBidResourcesEntry',
            component: WechatBidResourcesComponent,
            meta: { requiresAuth: true }
        }, {
            path: 'employee',
            name: 'employeeDefaultEntry',
            component: WechatEmployeeDefaultEntry,
            children: [{
                path: 'acceptOrder',
                name: 'employeeAcceptOrderEntry',
                component: WechatEmployeeAcceptOrderComponent,
                meta: { requiresAuth: true }
            }, {
                path: 'auditOrder',
                name: 'employeeAuditOrderEntry',
                component: WechatEmployeeAuditOrderComponent,
                meta: { requiresAuth: true }
            }, {
                path: 'orderInvoices',
                name: 'employeeOrderInvoicesEntry',
                component: () => import(/* webpackChunkName: "employeeOrderInvoicesEntry" */ '../components/wechat/employee/OrderInvoicesComponent.vue'),
                meta: { requiresAuth: true }
            }]
        }, {
            path: 'moduleDocs',
            component: WechatModuleDocsIndexComponent,
            meta: { requiresAuth: false },
            children: [{
                path: ':id',
                name: 'moduleDocDetailEntry',
                component: WechatModuleDocDetailComponent,
                meta: { requiresAuth: false }
            }, {
                path: '',
                name: 'moduleDocListEntry',
                component: WechatModuleDocsListComponent,
                meta: { requiresAuth: false, keepAlive: true }
            }]
        }]
    },
    {
        path: '/ops',
        component: OPSDefaultEntryComponent,
        children: [{
            path: 'login',
            name: 'opsLoginEntry',
            component: OPSLoginComponent,
            meta: { requiresAuth: false, navTitle: '登录' }
        }, {
            path: 'print/auditLogs',
            name: 'opsAuditLogsPrintEntry',
            component: OPSAuditLogPrintComponent,
            meta: { requiresAuth: true, navTitle: '打印审核记录' }
        }, {
            path: 'customers',
            name: 'opsCustomersListEntry',
            component: OPSIndexComponent,
            children: [{
                path: 'salorDailyLogs',
                component: OPSSalorDailyLogsComponent,
                meta: { requiresAuth: true, navTitle: '通话记录' }
            }, {
                path: 'contactFormLogs',
                component: OPSContactFormLogsComponent,
                meta: { requiresAuth: true, navTitle: '表单记录' }
            }, {
                path: 'contactFormJobs',
                component: () => import(/* webpackChunkName: "opsContactFormJobsImportEntry" */ '../views/ops/crm/ContactFormJobs.vue'),
                meta: { requiresAuth: true, navTitle: '表单任务' }
            }, {
                path: 'contactFormLogsImport',
                component: () => import(/* webpackChunkName: "opsContactFormLogsImportEntry" */ '../views/ops/crm/ContactFormLogsImport.vue'),
                meta: { requiresAuth: true, navTitle: '电话导入' }
            }, {
                path: 'contactFormsManage',
                component: () => import(/* webpackChunkName: "opsMarketContactFormManageEntry" */ '../views/ops/market/ContactFormManage.vue'),
                meta: { requiresAuth: true, navTitle: '表单管理' }
            }, {
                path: 'elecInvoiceLogs',
                component: OPSElecInvoiceLogsComponent,
                meta: { requiresAuth: true, navTitle: '电子发票' }
            }, {
                path: 'archives',
                component: OPSCustomerArchivesManage,
                meta: { requiresAuth: true, navTitle: '客户档案' }
            }, {
                path: 'contractInit',
                component: OPSContractInitComponent,
                meta: { requiresAuth: true, navTitle: '合同生成' }
            }, {
                path: 'coupons',
                component: OPSCouponsManage,
                meta: { requiresAuth: true, navTitle: '优惠券' }
            }, {
                path: 'simpleOrderSearch',
                name: 'opsSimpleSearchOrderEntry',
                component: OPSSimpleOrderTableComponent,
                meta: { requiresAuth: true, navTitle: '案例查询', keepAlive: true }
            }]
        }, {
            path: 'sysconfigs',
            name: 'opsWechatMPUsersEntry',
            component: OPSIndexComponent,
            children: [{
                path: 'wechatMPUsers',
                component: OPSWechatMPUsersComponent,
                meta: { requiresAuth: true, navTitle: '公众号用户' }
            }, {
                path: 'departments',
                component: OPSDepartmentsComponent,
                meta: { requiresAuth: true, navTitle: '公司部门' }
            }, {
                path: 'employees',
                component: OPSEmployeesComponent,
                meta: { requiresAuth: true, navTitle: '员工账号' }
            }, {
                path: 'dicts',
                component: OPSDictsManageComponent,
                meta: { requiresAuth: true, navTitle: '字典管理' }
            }, {
                path: 'datas',
                component: OPSDBAManageComponent,
                meta: { requiresAuth: true, navTitle: '数据管理' }
            }, {
                path: 'importPunchinRecords',
                component: OPSPunchinImportComponent,
                meta: { requiresAuth: true, navTitle: '考勤导入' }
            }, {
                path: 'importElecInvoiceLogs',
                component: OPSElecInvoiceLogsImportComponent,
                meta: { requiresAuth: true, navTitle: '电子发票' }
            }, {
                path: 'blacklist',
                component: OPSBlackListComponent,
                meta: { requiresAuth: true, navTitle: '黑名单' }
            }, {
                path: 'coupons',
                component: OPSSystemCouponsManage,
                meta: { requiresAuth: true, navTitle: '优惠券' }
            }, {
                path: 'ossFiles',
                component: OPSSystemOSSFilesManage,
                meta: { requiresAuth: true, navTitle: 'OSS文件' }
            }]
        }, {
            path: 'platManage',
            name: 'opsPlatManageEntry',
            component: OPSIndexComponent,
            children: [{
                path: 'userAudit',
                name: 'opsBusinessUserAuditEntry',
                component: OPSBusinessUserAuditComponent,
                meta: { requiresAuth: true, navTitle: '用户审核' }
            }]
        }, {
            path: 'docerJobs',
            name: 'opsDocerJobsEntry',
            component: OPSIndexComponent,
            children: [{
                path: 'me',
                name: 'opsMyDocerJobsView',
                component: () => import(/* webpackChunkName: "opsMyDocerJobsView" */ '../views/ops/order/docerJobs/MyDocerJobs.vue'),
                meta: { requiresAuth: true, navTitle: '我的任务', keepAlive: true }
            }, {
                path: 'audit',
                name: 'opsDocerJobsAuditView',
                component: () => import(/* webpackChunkName: "opsDocerJobsAuditView" */ '../views/ops/order/docerJobs/DocerJobsAudit.vue'),
                meta: { requiresAuth: true, navTitle: '任务审核', keepAlive: true }
            }, {
                path: 'statistics',
                name: 'opsDocerJobsStatisticsView',
                component: () => import(/* webpackChunkName: "opsDocerJobsStatisticsView" */ '../views/ops/order/docerJobs/Statistics.vue'),
                meta: { requiresAuth: true, navTitle: '任务统计', keepAlive: false }
            }, {
                path: 'moduleDocAudit',
                name: 'opsModuleDocAuditView',
                component: () => import(/* webpackChunkName: "opsModuleDocAuditView" */ '../views/ops/order/docerJobs/ModuleDocAudit.vue'),
                meta: { requiresAuth: true, navTitle: '方案审核', keepAlive: true }
            }, {
                path: 'materialFilesAudit',
                name: 'opsMaterialFilesAuditView',
                component: () => import(/* webpackChunkName: "opsMaterialFilesAuditView" */ '../views/ops/order/files/MaterialFilesAudit.vue'),
                meta: { requiresAuth: true, navTitle: '清单审核', keepAlive: false }
            }, {
                path: 'configs',
                name: 'opsDocerJobsConfigView',
                component: () => import(/* webpackChunkName: "opsDocerJobsConfigView" */ '../views/ops/order/docerJobs/Configs.vue'),
                meta: { requiresAuth: true, navTitle: '参数配置', keepAlive: false }
            }]
        }, {
            path: 'docerScore',
            name: 'opsDocerScoreEntry',
            component: OPSIndexComponent,
            children: [{
                path: 'configs',
                name: 'opsDocerScoreConfigView',
                component: () => import(/* webpackChunkName: "opsDocerScoreConfigView" */ '../views/ops/order/docerScore/Configs.vue'),
                meta: { requiresAuth: true, navTitle: '评分配置', keepAlive: false }
            }, {
                path: 'statistics',
                name: 'opsDocerScoreStatisticsView',
                component: () => import(/* webpackChunkName: "opsDocerScoreStatisticsView" */ '../views/ops/order/docerScore/Statistics.vue'),
                meta: { requiresAuth: true, navTitle: '评分统计', keepAlive: false }
            }, {
                path: 'list',
                name: 'opsDocerScoreListView',
                component: () => import(/* webpackChunkName: "opsDocerScoreListView" */ '../views/ops/order/docerScore/List.vue'),
                meta: { requiresAuth: true, navTitle: '评分列表', keepAlive: false }
            }]
        }, {
            path: 'orders',
            name: 'opsOrdersManageEntry',
            component: OPSIndexComponent,
            children: [{
                path: 'search',
                name: 'opsSearchOrderEntry',
                component: OPSOrderTableComponent,
                meta: { requiresAuth: true, navTitle: '查询订单', keepAlive: true }
            }, {
                path: 'create',
                name: 'opsCreateOrderEntry',
                component: () => import(/* webpackChunkName: "opscreateorderview" */ '../views/ops/order/CreateOrder.vue'),
                meta: { requiresAuth: true, navTitle: '创建订单' }
            }, {
                path: 'detail',
                name: 'opsOrderDetailEntry',
                component: () => import(/* webpackChunkName: "opsorderdetailview" */ '../views/ops/order/OrderDetailView.vue'),
                meta: { requiresAuth: true, navTitle: '订单详情' }
            }, {
                path: 'auditLogs',
                name: 'opsOrderAuditLogsEntry',
                component: OPSAuditLogTableComponent,
                meta: { requiresAuth: true, navTitle: '审核订单' }
            }, {
                path: 'boutiqueFileAudit',
                name: 'opsBoutiqueFileAuditEntry',
                component: () => import(/* webpackChunkName: "opsBoutiqueFileAuditView" */ '../views/ops/order/BoutiqueFileAudit.vue'),
                meta: { requiresAuth: true, navTitle: '精品标书审核' }
            }, {
                path: 'employeePerformance',
                name: 'opsEmployeePerformanceEntry',
                component: OPSEmployeePerformanceComponent,
                meta: { requiresAuth: true, navTitle: '制作人员绩效统计' }
            }, {
                path: 'salorPerformance',
                name: 'opsSalorPerformanceEntry',
                component: OPSSalorPerformanceComponent,
                meta: { requiresAuth: true, navTitle: '业务人员绩效统计' }
            }, {
                path: 'commonStatistics',
                name: 'opsCommonOrderStatisticsEntry',
                component: () => import(/* webpackChunkName: "opsStatisticsView" */ '../views/ops/order/Statistics.vue'),
                meta: { requiresAuth: true, navTitle: '统计订单', keepAlive: true  }
            }, {
                path: 'orderServicePriceStatistics',
                name: 'opsOrderServicePriceStatisticsEntry',
                component: OPSOrderServicePriceStatisticsComponent,
                meta: { requiresAuth: true, navTitle: '服务金额明细' }
            }, {
                path: 'docModuleJobs',
                name: 'opsOrderDocModuleJobsEntry',
                component: () => import(/* webpackChunkName: "opsStatisticsView" */ '../views/ops/order/DocModuleJobs.vue'),
                meta: { requiresAuth: true, navTitle: '技术方案任务管理' }
            }, {
                path: 'ca',
                component: () => import(/* webpackChunkName: "opsCAEntry" */ '../views/ops/order/CA.vue'),
                meta: { requiresAuth: true, navTitle: 'CA管理' }
            }]
        }, {
            path: 'payments',
            name: 'opsPaymentsManageEntry',
            component: OPSIndexComponent,
            children: [{
                path: 'auditCreate',
                name: 'opsPaymentsAuditCreateEntry',
                component: OPSCreatePaymentAuditComponent,
                meta: { requiresAuth: true, navTitle: '新增订单支付审批' }
            }, {
                path: 'weixin',
                name: 'opsPaymentsWXLogsEntry',
                component: OPSWXPaymentLogsComponent,
                meta: { requiresAuth: true, navTitle: '微信账户支付管理' }
            }]
        }, {
            path: 'finance',
            name: 'opsFinanceManageEntry',
            component: OPSIndexComponent,
            children: [{
                path: 'addInvoice',
                name: 'opsFinanceAddInvoiceEntry',
                component: OPSAddInvoiceComponent,
                meta: { requiresAuth: true, navTitle: '发票录入' }
            }, {
                path: 'invoiceLogs',
                name: 'opsFinanceInvoiceLogsEntry',
                component: OPSInvoiceLogsComponent,
                meta: { requiresAuth: true, navTitle: '开票记录查询', keepAlive: true }
            }, {
                path: 'paymentAuditCheck',
                name: 'opsPaymentAuditCheckEntry',
                component: OPSPaymentAuditCheckTableComponent,
                meta: { requiresAuth: true, navTitle: '支付审核' }
            }, {
                path: 'paymentAuditLogs',
                name: 'opsPaymentAuditLogsEntry',
                component: () => import(/* webpackChunkName: "opsPaymentAuditLogsEntry" */ '../views/ops/finance/OrderPaymentAudits.vue'),
                meta: { requiresAuth: true, navTitle: '服务变更明细', keepAlive: true }
            }, {
                path: 'orders',
                name: 'opsFinanceOrderTableEntry',
                component: OPSFinanceOrderTableComponent,
                meta: { requiresAuth: true, navTitle: '订单查询', keepAlive: true }
            }, {
                path: 'orderMonthSum',
                name: 'opsOrderMonthSumTableEntry',
                component: OPSOrderMonthSumTableComponent,
                meta: { requiresAuth: true, navTitle: '订单月度统计' }
            }, {
                path: 'receiveAccountBalances',
                name: 'opsReceiveAccountBalancesEntry',
                component: OPSReceiveAccountBalancesComponent,
                meta: { requiresAuth: true, navTitle: '账户余额', keepAlive: true }
            }, {
                path: 'settlements',
                name: 'opsFinanceAccountSettlementsEntry',
                component: OPSFinanceAccountSettlementsTable,
                meta: { requiresAuth: true, navTitle: '结算查询', keepAlive: true }
            }, {
                path: 'receiveAccountLogs',
                name: 'opsReceiveAccountLogsEntry',
                component: () => import(/* webpackChunkName: "opsReceiveAccountLogsEntry" */ '../views/ops/finance/OrderPayments.vue'),
                meta: { requiresAuth: true, navTitle: '账户流水明细', keepAlive: true }
            }, {
                path: 'punchinsCheck',
                name: 'opsPunchinsCheckEntry',
                component: OPSPunchinsCheckTableComponent,
                meta: { requiresAuth: true, navTitle: '考勤统计' }
            }, {
                path: 'punchinVacationCheck',
                name: 'opsPunchinVacationCheckEntry',
                component: OPSPunchinVacationCheckComponent,
                meta: { requiresAuth: true, navTitle: '请假审批' }
            }, {
                path: 'corpPayorders',
                name: 'opsFinanceCorpPayOrderTableEntry',
                component: OPSFinanceCorpPayOrderTableComponent,
                meta: { requiresAuth: true, navTitle: '公户订单查询', keepAlive: true }
            }, {
                path: 'corpPaymentLogs',
                name: 'opsFinanceCorpPaymentLogsEntry',
                component: OPSFinanceCorpPaymentLogsComponent,
                meta: { requiresAuth: true, navTitle: '公户流水查询', keepAlive: true }
            }, {
                path: 'dailyRecords',
                name: 'opsFinanceDailyRecordsEntry',
                component: () => import(/* webpackChunkName: "opsfinancedailyrecordsentry" */ '../views/ops/finance/DailyRecords.vue'),
                meta: { requiresAuth: true, navTitle: '台账管理'}
            }, {
                path: 'car',
                component: () => import(/* webpackChunkName: "opsCAREntry" */ '../views/ops/org/Car.vue'),
                meta: { requiresAuth: true, navTitle: '车辆管理' }
            }]
        }, {
            path: 'resources',
            name: 'opsResourcesManageEntry',
            component: OPSIndexComponent,
            children: [{
                path: 'techProgram',
                name: 'opsTechProgramResourcesEntry',
                component: OPSTechProgramResourcesComponent,
                meta: { requiresAuth: true, navTitle: '技术方案' }
            }, {
                path: 'businessFiles',
                name: 'opsBusinessFilesResourcesEntry',
                component: OPSBusinessFilesResourcesComponent,
                meta: { requiresAuth: true, navTitle: '商务资料' }
            }, {
                path: 'trainFiles',
                name: 'opsTrainFilesResourcesEntry',
                component: OPSTrainFilesResourcesComponent,
                meta: { requiresAuth: true, navTitle: '培训资料' }
            }, {
                path: 'budgetFiles',
                name: 'opsBudgetFilesResourcesEntry',
                component: () => import(/* webpackChunkName: "opsbudgetfilesresourcessentry" */ '../components/ops/resources/BudgetFilesComponent.vue'),
                meta: { requiresAuth: true, navTitle: '预算资料' }
            }, {
                path: 'budgetMaterialPrices',
                name: 'opsBudgetMaterialPricesEntry',
                component: () => import(/* webpackChunkName: "opsbudgetmaterialpricesentry" */ '../views/ops/resources/BudgetMaterialPrices.vue'),
                meta: { requiresAuth: true, navTitle: '预算数据' }
            }, {
                path: 'companyResources',
                name: 'opsCompanyResourcesEntry',
                component: () => import(/* webpackChunkName: "opsCompanyResourcesEntry" */ '../views/ops/resources/CompanyResources.vue'),
                meta: { requiresAuth: true, navTitle: '公司资料' }
            }]
        }, {
            path: 'self',
            component: OPSIndexComponent,
            children: [{
                path: '',
                name: 'opsSelftDefaultEntry',
                component: OPSSelfDefaultEntryComponent,
                meta: { requiresAuth: true, navTitle: '个人中心' }
            }, {
                path: 'punchinRecords',
                name: 'opsSelfPunchinRecordsEntry',
                component: OPSPunchinManageComponent,
                meta: { requiresAuth: true, navTitle: '考勤管理' }
            }]
        }, {
            path: 'hr',
            name: 'opsHREntry',
            component: OPSIndexComponent,
            children: [{
                path: 'employees',
                name: 'opsHREmployeeEntry',
                component: OPSHREmployeesComponent,
                meta: { requiresAuth: true, navTitle: '员工信息' }
            }, {
                path: 'employeeAuditLogs',
                name: 'opsEmployeeAuditLogsEntry',
                component: () => import(/* webpackChunkName: "opsemployeeauditlogsview" */ '../views/ops/hr/EmployeeAuditLogs.vue'),
                meta: { requiresAuth: true, navTitle: '员工变更审批' }
            }, {
                path: 'companyPhones',
                component:  () => import(/* webpackChunkName: "opsCompanyPhonesEntry" */ '../views/ops/hr/CompanyPhones.vue'),
                meta: { requiresAuth: true, navTitle: '公司电话' }
            }]
        }, {
            path: 'market',
            name: 'opsMarketEntry',
            component: OPSIndexComponent,
            children: [{
                path: 'index',
                name: 'opsMarketIndexEntry',
                component: () => import(/* webpackChunkName: "opsMarketIndexEntry" */ '../views/ops/market/Index.vue'),
                meta: { requiresAuth: true, navTitle: '推广管理'},
            }]
        }, {
            path: 'chuyaji',
            name: 'opsChuyajiEntry',
            component: OPSIndexComponent,
            meta: { requiresAuth: true, navTitle: '初芽纪母婴'},
            children: [{
                path: 'orders',
                name: 'opsChuyajiOrdersEntry',
                component: () => import(/* webpackChunkName: "opsChuyajiIndexEntry" */ '../views/ops/chuyaji/Orders.vue'),
                meta: { requiresAuth: true, navTitle: '订单管理'},
            }]
        }, {
            path: '',
            component: OPSIndexComponent,
            meta: { requiresAuth: true, navTitle: '首页' },
            children: [{
                path: '',
                component: OPSDashboardComponent,
                meta: { requiresAuth: true, navTitle: '控制台' }
            }]
        }]
    },
    { 
        path: '*', 
        component: NotFoundComponent 
    }
]


// Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = new VueRouter({
    mode: 'history',
    routes, // short for `routes: routes`
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
          return savedPosition
        } else {
          return { x: 0, y: 0 }
        }
      }
})

router.beforeEach((to, from, next) => {

    if(to.meta.requiresAuth && 
        !Vue.prototype.$cookie.get(store.state.cookie.userTokenKey) &&
        !to.query.token &&
        to.path != '/ops/login' &&
        to.path != '/auth/wechat'){
        // 第一次进入项目
        Vue.prototype.$cookie.set(store.state.cookie.beforeLoginURLKey, to.fullPath) // 保存用户进入的url
        
        if (to.path.indexOf('/ops') === 0) {
            Vue.prototype.$cookie.set(store.state.cookie.opsBeforeLoginURLKey, to.fullPath) // 保存用户进入的url

            next('/ops/login');
        } else {
            next('/auth/wechat');
        }

        return false
    } else if (to.query.token) {
        Vue.prototype.$cookie.set(store.state.cookie.userTokenKey, to.query.token);
        
        delete to.query.token
    
        NProgress.start();   
        next({path: to.path, query: to.query})
    } else {

        NProgress.start();   
        next();
    }

});

router.afterEach((to, from) => {
    //	关闭进度条
	NProgress.done();
})

export default router



// WEBPACK FOOTER //
// ./src/route/index.js